export default __webpack_public_path__ + "static/media/stdf-logo.e822bd8c.png";